import React from "react";
import { Card, CardBody } from "reactstrap";
import ReactSwitch from "react-switch";
import classnames from "classnames";

import { DESIGNATION_CSS_MAP, HIDDEN_MODES_OF_SALE } from "../constants";

type Props = {
    sortedVisibility: any[];
    onToggle: (item: any, e: any, key: number) => void;
    setIsEdited: (v: boolean) => void;
    isFieldDisabled: boolean;
    isCentralizationActive: boolean;
    isConsultModalOpened: boolean;
    isConsult?: boolean;
};

export default function SaleModeList({
    sortedVisibility,
    onToggle,
    setIsEdited,
    isFieldDisabled,
    isCentralizationActive,
    isConsultModalOpened,
    isConsult,
}: Props) {
    const visibleModes = sortedVisibility.filter(
        (modeOfSale: any) =>
            !HIDDEN_MODES_OF_SALE.includes(modeOfSale.designation)
    );

    return (
        <Card className={`mt-1 ${isConsult ? "pe-none__clz" : ""}`}>
            <CardBody>
                {visibleModes.map((modeOfSale: any, key: number) => (
                    <div
                        key={modeOfSale.designation}
                        className="text-danger row align-items-center"
                    >
                        <div
                            className="d-flex col-4"
                            style={{ color: "#212529 " }}
                        >
                            <div>
                                <h6 style={{ width: "85px" }}>
                                    {modeOfSale.designation}
                                </h6>
                            </div>
                            <div>
                                <ReactSwitch
                                    data-testid={`fidelity-franchise-sale-mode-switch-${modeOfSale.designation}`}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    handleDiameter={26}
                                    offColor="#f7b4b8"
                                    offHandleColor="#E30613"
                                    checked={modeOfSale.state}
                                    onChange={(e: any) => {
                                        setIsEdited(true);
                                        onToggle(modeOfSale, e, key);
                                    }}
                                    onColor="#c2eddd"
                                    onHandleColor="#34C38F"
                                    width={55}
                                    height={20}
                                    disabled={
                                        isCentralizationActive &&
                                        isConsultModalOpened
                                    }
                                    className={classnames(
                                        "fed_icn_FRmodeOfSales",
                                        {
                                            "not-allowed-icon__clz": isFieldDisabled,
                                        },
                                        DESIGNATION_CSS_MAP[
                                            modeOfSale.designation
                                        ] ?? ""
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </CardBody>
        </Card>
    );
}
